import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	filterIconLabel: {
		id: 'filter',
		defaultMessage: 'Filter icon',
		description: 'Filter icon label text',
	},
});
